import classNames from 'classnames';

interface InfoCardProps {
  icon: string;
  iconBg?: string;
  className?: string;
  children: React.ReactNode;
}

export const InfoCard = ({
  icon,
  iconBg,
  className,
  children,
}: InfoCardProps) => {
  return (
    <div
      className={classNames(
        'max-w-xl flex items-center px-6 py-5 bg-white rounded-lg',
        className
      )}
    >
      <div
        className={classNames(
          'w-12 h-12 flex items-center justify-center shrink-0',
          iconBg ? 'rounded-lg' : ''
        )}
        style={iconBg ? { backgroundColor: iconBg } : undefined}
      >
        <img
          src={icon}
          alt=""
          className={iconBg ? 'w-6 h-6' : 'w-full h-full'}
        />
      </div>
      <div className="pl-4 grow-0">{children}</div>
    </div>
  );
};
